import {
  InsurancePolicy,
  InsurancePolicyType,
} from '@advisory-report/src/types/AdvisoryReport';
import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { Document } from '../../../../../../../types/ToolkitDashboard';
import { wgApi } from '../../../../../../app/src/features/api/wgApi';

interface Params {
  documentId?: string;
  /** IMPORTANT: Make sure the filename is decoded */
  filename?: string;
  type: InsurancePolicyType;
}

interface InsurancePolicyExtractionData {
  items: InsurancePolicy[];
}

export const postInsurancePolicyExtraction = async (
  document_id: string,
  filename?: string,
  type?: InsurancePolicyType,
): Promise<InsurancePolicyExtractionData> => {
  const { data: doc, isError: isDocError } = await wgApi.get<Document>(
    `/v1/api/documents/${document_id}`,
  );

  if (isDocError || !doc) throw new Error('Error fetching document link');
  const insurancesPath = `/v1/api/document-extractor/one/insurance-policies`;
  const offersPath = `/v1/api/document-extractor/one/offers`;

  const path = type === 'OFFER' ? offersPath : insurancesPath;
  const { data, isError } = await wgApi.post<InsurancePolicyExtractionData>(
    path,
    {
      link: doc.link,
      document_id: document_id,
      filename: filename,
    },
  );
  if (isError) throw new Error();
  return data;
};

export const getUseInsurancePolicyExtractionQKey = (
  document_id?: string,
  type?: string,
) => ['insurance-policy-extraction', type, document_id];

export const useInsurancePolicyExtraction = (
  params?: Params,
  queryOptions?: UseQueryOptions<
    InsurancePolicyExtractionData,
    unknown,
    InsurancePolicyExtractionData
  >,
): UseQueryResult<InsurancePolicyExtractionData> => {
  const { documentId, filename, type } = params || {};

  return useQuery<InsurancePolicyExtractionData>(
    getUseInsurancePolicyExtractionQKey(documentId, type),
    () => postInsurancePolicyExtraction(documentId!, filename, type),
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      enabled: !!documentId,
      retry: false,
      ...queryOptions,
    },
  );
};
